const isRunningAsRemote = typeof window !== 'undefined' && !!window.IS_HOSTED_REMOTE;

if (typeof window !== 'undefined' && typeof document !== 'undefined' && !isRunningAsRemote) {
  const originalCreateElement = document.createElement;
  document.createElement = function (tagName: string, options?: ElementCreationOptions) {
    const element = originalCreateElement.call(document, tagName, options);

    if (tagName.toLowerCase() === 'script') {
      const script = element as HTMLScriptElement;
      let scriptSrc: string | null = null;

      Object.defineProperty(script, 'src', {
        get: () => scriptSrc || '',
        set: (value: string) => {
          if (value && value.includes('remoteEntry.js') && !value.includes('/assets/')) {
            scriptSrc = null;
            return;
          }
          scriptSrc = value;
          element.setAttribute('src', value);
        },
        configurable: true,
      });

      const originalSetAttribute = script.setAttribute.bind(script);
      script.setAttribute = function (name: string, value: string) {
        if (
          name === 'src' &&
          value &&
          value.includes('remoteEntry.js') &&
          !value.includes('/assets/')
        ) {
          return;
        }
        return originalSetAttribute(name, value);
      };
    }
    return element;
  };

  const originalImport = window.__import__ || ((url: string) => import(url));
  window.__import__ = async function (url: string) {
    if (url && url.includes('remoteEntry.js')) {
      try {
        const urlObj = new URL(url, window.location.href);
        if (urlObj.origin !== window.location.origin) {
          return Promise.reject(new Error('Remote remoteEntry.js blocked by Guard in SPA mode'));
        }
      } catch (e) {
        // Invalid URL, allow it
      }
    }
    return originalImport(url);
  };
}
